module.exports = __webpack_public_path__ + "static/img/null.1c2a72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/null.png
// module id = 2u6q
// module chunks = 1